const hideForCountries = [
    "AX", "AL", "AD", "AM", "AU", "BY", "BA", "BR",
    "CN", "CK", "GM", "GE", "GI", "GL", "GP", "GG",
    "IS", "IN", "IM", "JP", "JE", "XK", "LI", "MU",
    "YT", "MD", "MC", "ME", "MA", "NZ", "NU", "MK",
    "NO", "RE", "SM", "SN", "RS", "SG", "BL", "SJ",
    "TR", "VU"
];
 
document.addEventListener('DOMContentLoaded', () => {
    if (hideForCountries.includes(Shopify.country)) {
        const elements = document.querySelectorAll('.price__notes');
        elements.forEach(element => {
            const firstNoteItem = element.querySelectorAll('.price__note--tax')[0];
            firstNoteItem.style.display = "none";
        });
    }
 
    if(document.querySelector('.cart__message')){
        const cartNote = document.querySelector('.cart__message');
        let currentText = cartNote.innerHTML;
        let newText = currentText.replace('Tax included. ', '');
        if (hideForCountries.includes(Shopify.country)) {
            cartNote.innerHTML = newText;
        }
    }
})



document.addEventListener('DOMContentLoaded', () => {
    // Mehrsprachige Produktliste
    const targetProductTitles = {
        "en": ["EasyDens for Beer", "EasyDens", "SmartRef", "EasyDens & SmartRef Combo", "EasyDens for Wine", "EasyDens for Spirits", "EasyDens for Kombucha", "EasyDens for Hard Seltzer", "Homebrewer's Kit", "Winemaker's Kit"],
        "de": ["EasyDens für Bier","EasyDens", "SmartRef", "EasyDens & SmartRef Combo", "EasyDens für Wein", "EasyDens für Spirituosen", "EasyDens für Kombucha", "EasyDens für Hard Seltzer", "Heimbrauer-Set", "Winzer-Set"],
        "fr": ["EasyDens pour la bière", "EasyDens", "SmartRef", "EasyDens & SmartRef Combo", "EasyDens pour le vin", "EasyDens pour les spiritueux", "EasyDens pour le kombucha", "EasyDens pour le hard seltzer", "Kit de brasseur amateur", "Kit du vigneron"],
        "it": ["EasyDens per la birra", "EasyDens", "SmartRef", "EasyDens & SmartRef Combo", "EasyDens per il vino", "EasyDens per i distillati", "EasyDens per il kombucha", "EasyDens per l'hard seltzer", "Kit per homebrewer", "Kit per l'enologo"]
    };

    // Versandtexte für verschiedene Sprachen
    const shippingTexts = {
    "en": "Shipping calculated at checkout",
    "de": "Versand wird beim Checkout berechnet",
    "fr": "Frais d'expédition calculés à l'étape de paiement",
    "it": "Spese di spedizione calcolate al check-out."
};


    // Kostenloser Versand-Text je nach Sprache
    const freeShippingTexts = {
        "en": '<a href="/policies/shipping-policy">Free Shipping</a>',
        "de": '<a href="/policies/shipping-policy">Gratis Versand</a>',
        "fr": '<a href="/policies/shipping-policy">Livraison gratuite</a>',
        "it": '<a href="/policies/shipping-policy">Spedizione gratuita</a>'
    };

    function detectLanguage() {
        let lang = document.documentElement.lang || "en"; // Falls keine Sprache gesetzt ist, Standard Englisch
        lang = lang.split('-')[0]; // Falls die Sprache als "de-DE" oder "fr-FR" kommt, nur "de", "fr" nehmen

        if (!targetProductTitles[lang]) {
            lang = "en"; // Fallback auf Englisch, falls Sprache nicht in der Liste
        }
        return lang;
    }

    function updateShippingText() {
        const lang = detectLanguage(); // Aktuelle Sprache abrufen
        const productsInLang = targetProductTitles[lang]; // Produktliste für aktuelle Sprache holen

        // Produktnamen aus dem HTML holen
        let productTitleElement = document.querySelector('.product-featured__title.section__title a') || 
                                  document.querySelector('.product-single__title');

        let productTitle = productTitleElement ? productTitleElement.innerText.trim() : "";

        // Prüfen, ob das Produkt in der Liste ist
        if (productsInLang.includes(productTitle)) {
            const priceNotes = document.querySelectorAll('.price__note');

            // **Nur das dritte .price__note-Element ändern (Versandinfo)**
            if (priceNotes.length > 2 && priceNotes[2].innerText.includes(shippingTexts[lang])) {
                priceNotes[2].innerHTML = freeShippingTexts[lang]; // Setzt den passenden "Free Shipping"-Text
            }
        }
    }

    // **Direkt beim Laden ausführen**
    updateShippingText();

    // **Falls Shopify Inhalte nachträglich lädt, MutationObserver aktivieren**
    const observer = new MutationObserver(updateShippingText);
    observer.observe(document.body, { childList: true, subtree: true });
});

